/**
 * Environment object that specifies communication endpoints for the SDK
 * @export
 * @class Environment
 */
export class Environment {
  /**
   * Sandbox environment. This is the default one. Use it for development.
   */
  public static Sandbox = new Environment("https://webapi.developers.erstegroup.com/api/csas/public/sandbox", "https://webapi.developers.erstegroup.com/api/csas/sandbox/v1/sandbox-idp")

  /**
   * Production environment of CSAS. Use it in production with production API Key.
   */
  public static Production = new Environment("https://www.csas.cz/webapi", "https://bezpecnost.csas.cz/mep/fs/fl/oauth2")

  /**
  * Base URL path. Start of API context
  */
  apiContextBaseUrl: string;

  /**
   Base URL path for OAuth2 authentication.
  */
  oAuth2ContextBaseUrl: string;

  /**
   * Creates new Environment instance
   *
   * @param apiContextBaseUrl Base URL path. Start of API context
   * @param oAuth2ContextBaseUrl Base URL path for OAuth2 authentication.
   */
  public constructor(apiContextBaseUrl: string, oAuth2ContextBaseUrl: string) {
    this.apiContextBaseUrl = apiContextBaseUrl;
    this.oAuth2ContextBaseUrl = oAuth2ContextBaseUrl;
  }
}




// WEBPACK FOOTER //
// ./lib/core/environment.ts